import Vuetify from "vuetify";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  ADD_INNER_TO_ACCUMULATOR,
  COLLECTIONS_MAP,
  DELETE_INNER_CONDITONS,
  DELETE_INNER_INFO_GROUP_CONDITONS,
  FILTERS_NAMES_CONST,
  GENERAL_RULES_CONSTANTS,
  LIST_OF_COLLECTIONS_WITH_CUPS_INNER_CONDITIONS,
  LIST_OF_COLLECTIONS_WITH_FIELDS_IN_FORMS,
  MODIFY_ENTRIES,
  REQUIRED_ORDER_IN_CUPS,
  SECOND_LEVEL
} from "@/modules/GeneralRules/constants/GeneralRulesConstants";
import { Collection } from "@/modules/GeneralRules/models/Collection.model";
import DisplayValue from "../../StopConditions/components/DisplayValue/DisplayValue.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import { FORM_VALIDATORS } from "@/shared/constants/FormConstants";
import { InnerCondition } from "@/modules/GeneralRules/models/InnerConditions.model";

Vue.use(Vuetify);

@Component({
  name: "InnerConditionComponent",
  components: {
    DisplayValue
  }
})
export default class InnerConditionComponent extends Vue {
  @Prop() private index?: number;
  @Prop() private indexMacro?: number;
  @Prop() private fields!: any[];
  @Prop() private keyProp!: string;
  @Prop() private operationProp!: string;
  @Prop() private valueProp!: any;
  @Prop() private collection!: Collection;
  @Prop() private btnStatus!: boolean;
  @Prop() private keySet!: string[];
  @Prop() private isInfoGroupsConditionsActivated!: boolean;
  @Prop() private sectionsGroupsThirdLevelEnable!: boolean;
  @Prop({ default: () => 0 })
  private accumulativeObjectArrayToServiceCollectionLength!: number;
  @Prop() private propertyOfCollection!: string;
  @Prop() private level!: number;

  requiredFieldAndBlankSpaces = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES
  ];

  cardClass = STYLE_CLASSES.CARD;
  iconBtnClass = STYLE_CLASSES.ICON_BTN;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  roundPrimaryBtnClass = STYLE_CLASSES.ROUND_BTN_CLASS;
  DELETE_CONDITION = GENERAL_RULES_CONSTANTS.TOOLTIP.DELETE_CONDITION;
  INNER_CONDITION = GENERAL_RULES_CONSTANTS.TOOLTIP.INNER_CONDITION;

  keyAttr: string = this.keyProp ?? "";
  opsAttr: string = this.operationProp ?? "";
  displayOperator = this.operationProp ?? "";
  displayValue = this.valueProp ?? "";
  keySetProp = this.keySet ?? [];
  opsItems = [];

  mounted() {
    if (this.keyAttr.length > 0 && this.fields.length > 0) {
      this.opsItems = this.fields?.filter(
        field => field.key === this.keyAttr
      )[0].operatorList;
    }
  }

  deleteInnerCondition(index: number) {
    if (this.isInfoGroupsConditionsActivated) {
      return this.$emit(
        DELETE_INNER_INFO_GROUP_CONDITONS,
        index,
        this.level,
        this.indexMacro
      );
    }
    if (this.sectionsGroupsThirdLevelEnable) {
      return this.$emit(
        GENERAL_RULES_CONSTANTS.EMITTERS.DELETE_SESSION_GROUPS_CONDITION,
        index,
        this.level,
        this.indexMacro
      );
    }
    this.$emit(DELETE_INNER_CONDITONS, index, this.indexMacro);
  }

  emittersToDeepLevelConditionComponent() {
    this.$emit(
      MODIFY_ENTRIES.VALUE,
      this.displayValue,
      this.indexMacro,
      this.index,
      this.level
    );
    this.$emit(
      MODIFY_ENTRIES.KEY,
      this.keyAttr,
      this.indexMacro,
      this.index,
      this.level
    );
    this.$emit(
      MODIFY_ENTRIES.OPERATION,
      this.opsAttr,
      this.indexMacro,
      this.index,
      this.level
    );
  }

  @Watch("keyAttr")
  changeKeyAttr() {
    if (this.keyAttr && this.keySet.includes(this.keyAttr)) {
      this.keyAttr = "";
      Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.EXIST_CONDITION);
      return;
    }
    this.opsAttr = "";
    this.displayValue = "";

    this.emittersToDeepLevelConditionComponent();

    if (this.keyAttr.length > 0) {
      this.opsItems = this.fields?.filter(
        field => field.key === this.keyAttr
      )[0].operatorList;
    }
  }

  @Watch("opsAttr")
  changeOpsAttr() {
    this.displayValue = "";
    this.$emit(
      MODIFY_ENTRIES.OPERATION,
      this.opsAttr,
      this.indexMacro,
      this.index,
      this.level
    );
    this.$emit(
      MODIFY_ENTRIES.VALUE,
      this.displayValue,
      this.indexMacro,
      this.index,
      this.level
    );
    this.displayOperator = this.opsAttr;
  }

  isAddingButtonActivated() {
    const currentLocation = COLLECTIONS_MAP.filter(
      collection => collection.attrValue === this.collection.name
    );

    if (currentLocation.length > 0) {
      if (
        LIST_OF_COLLECTIONS_WITH_FIELDS_IN_FORMS.includes(this.collection.key)
      ) {
        if (
          this.level === SECOND_LEVEL &&
          Array.isArray(this.displayValue) &&
          this.displayValue.length > 1
        ) {
          return false;
        }

        if (this.btnStatus) {
          return true;
        }
        return (
          this.collection.key === FILTERS_NAMES_CONST.FORM.KEY &&
          this.propertyOfCollection === GENERAL_RULES_CONSTANTS.SERVICIO &&
          this.level === 2 &&
          this.displayValue &&
          this.accumulativeObjectArrayToServiceCollectionLength === 0
        );
      }
    }
    return false;
  }

  inputDataForDisplayComponent() {
    const collectionKey = this.collection.key;
    if (
      LIST_OF_COLLECTIONS_WITH_CUPS_INNER_CONDITIONS.includes(collectionKey)
    ) {
      return REQUIRED_ORDER_IN_CUPS;
    } else if (collectionKey === FILTERS_NAMES_CONST.FORM.KEY) {
      const formField = this.fields.filter(field => field.key === this.keyAttr);

      if (this.level === SECOND_LEVEL) {
        return {
          field: formField[0].key,
          key: formField[0].key,
          display: formField[0].display,
          operators: [],
          value: formField[0].valueList
        };
      }

      const fieldToDisplay = this.fields.filter(
        field => field.key === this.keyAttr
      );

      return {
        field: fieldToDisplay[0].key,
        key: fieldToDisplay[0].key,
        display: fieldToDisplay[0].display,
        operators: [],
        value: fieldToDisplay[0].valueList
      };
    } else if (collectionKey === FILTERS_NAMES_CONST.USER.KEY) {
      if (this.level === SECOND_LEVEL) {
        return {
          field: this.fields[0].key,
          key: this.fields[0].key,
          display: this.fields[0].display,
          operators: [],
          value: this.fields[0].valueList
        };
      }
      const fieldToDisplay = this.fields.filter(
        field => field.key === this.keyAttr
      );

      return {
        field: fieldToDisplay[0].key,
        key: fieldToDisplay[0].key,
        display: fieldToDisplay[0].display,
        operators: [],
        value: fieldToDisplay[0].valueList
      };
    }
  }

  setValueFromDisplay(value: any) {
    this.displayValue = value;
    this.emittersToDeepLevelConditionComponent();
  }

  addMoreInnerCondtions() {
    this.$emit(ADD_INNER_TO_ACCUMULATOR, {
      key: "",
      operation: "",
      value: "",
      collection: this.collection,
      index: this.index,
      fields: this.fields
    } as InnerCondition);
  }

  validateIsDisabled() {
    if (
      (Array.isArray(this.displayValue) && this.displayValue.length === 0) ||
      this.displayValue === ""
    ) {
      this.INNER_CONDITION = GENERAL_RULES_CONSTANTS.TOOLTIP.TEMPLATE_CONDITION;
      return true;
    }

    this.INNER_CONDITION = GENERAL_RULES_CONSTANTS.TOOLTIP.INNER_CONDITION;
    return false;
  }
}
